import { Box, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useAppForm } from "../../hooks/preferenceForm";
import { AllOnPreferences } from "./components/AllOnPreferences";
import { ImplantProsthesisPreferences } from "./components/ImplantProsthesisPreferences";
import { ImplantSystemPreferences } from "./components/ImplantSystemPreferences";
import { getImplantPreferenceDefaults } from "./implantPreferenceForm";

const ImplantPreferences = () => {
  const form = useAppForm({
    defaultValues: getImplantPreferenceDefaults(),
  });

  return (
    <form>
      <Stack pb="s16">
        <ImplantSystemPreferences form={form} />

        <ImplantProsthesisPreferences form={form} />

        <AllOnPreferences form={form} />

        <Box
          display="flex"
          p="s4"
          bg="var(--mantine-color-ink-0)"
          bdrs="md"
          style={{
            alignItems: "center",
            gap: "var(--mantine-spacing-s3)",
            border: "1px solid var(--mantine-color-ink-1)",
          }}
        >
          <IconInfoCircle size={22} color="var(--mantine-color-ink-6)" />
          <Text>
            Le pilier et l&lsquo;analogue se choisissent commande par commande :
            ils dépendent du cas, jamais d&lsquo;une préférence.
          </Text>
        </Box>
      </Stack>
    </form>
  );
};

export default ImplantPreferences;
